 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TITLE_PAGE from '@/components/title_page'
 import LOVE_1 from '@/components/love_1'
 import CHAP113193 from '@/components/chap113193'
 import CHAP112901 from '@/components/chap112901'
 import CHAP112887 from '@/components/chap112887'
 import CHAP112886 from '@/components/chap112886'
 import CHAP112891 from '@/components/chap112891'
 import CHAP112890 from '@/components/chap112890'
 import CHAP112902 from '@/components/chap112902'
 import CHAP112903 from '@/components/chap112903'
 import CHAP112904 from '@/components/chap112904'
 import CHAP112898 from '@/components/chap112898'
 import CHAP112881 from '@/components/chap112881'
 import CHAP112899 from '@/components/chap112899'
 import CHAP112905 from '@/components/chap112905'
 import CHAP112892 from '@/components/chap112892'
 import CHAP112897 from '@/components/chap112897'
 import CHAP112888 from '@/components/chap112888'
 import CHAP112883 from '@/components/chap112883'
 import CHAP112882 from '@/components/chap112882'
 import CHAP112900 from '@/components/chap112900'
 import CHAP112884 from '@/components/chap112884'
 import CHAP112894 from '@/components/chap112894'
 import CHAP112895 from '@/components/chap112895'
 import CHAP112906 from '@/components/chap112906'
 import LOVE_2 from '@/components/love_2'
 import CHAP112893 from '@/components/chap112893'
 import CHAP112896 from '@/components/chap112896'
 import CHAP112885 from '@/components/chap112885'
 import CHAP113194 from '@/components/chap113194'
 import CREDITS from '@/components/credits'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/title_page",
 			"name" : "title_page",
 			"component" : TITLE_PAGE
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/chap113193",
 			"name" : "chap113193",
 			"component" : CHAP113193
 		},
 		{
 			"path" : "/chap112901",
 			"name" : "chap112901",
 			"component" : CHAP112901
 		},
 		{
 			"path" : "/chap112887",
 			"name" : "chap112887",
 			"component" : CHAP112887
 		},
 		{
 			"path" : "/chap112886",
 			"name" : "chap112886",
 			"component" : CHAP112886
 		},
 		{
 			"path" : "/chap112891",
 			"name" : "chap112891",
 			"component" : CHAP112891
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js